import i18n from '../i18n';

export default class InsuranceType {
  public static readonly UNDEFINED = new InsuranceType('', '-');
  public static readonly UNINSURED = new InsuranceType('0', 'sellerReference.insuranceFlag.uninsured');
  public static readonly INSURED = new InsuranceType('1', 'sellerReference.insuranceFlag.insured');

  public static values(): any {
    return [
      { value: this.UNINSURED.value, text: i18n.t(this.UNINSURED.text) },
      { value: this.INSURED.value, text: i18n.t(this.INSURED.text) },
    ];
  }

  public static valueOf(value: string): InsuranceType {
    for (const v of this.values()) {
      if (v.value === value) {
        return v;
      }
    }
    return InsuranceType.UNDEFINED;
  }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: InsuranceType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
